export const radius = {
  none: "0px",
  xxs: "1px",
  xs: "4px",
  md: "6px",
  lg: "8px",
  xl: "16px",
  full: "99999px",
} as const;

export type RadiusKeys = keyof typeof radius;
export type Radius = typeof radius;
